<template>
    <div class="page-content">
        <!-- header -->
        <div class="d-flex justify-content-between align-items-center flex-wrap mb-2">
            <div class="mb-2">
                <div class="my-2">
                    <h3 class="mb-2 mb-md-0">Competency Management</h3>
                </div>
            </div>
            <div class="d-flex gap-2">
                <div class="top_heading_CreatePartner_btn position-relative z-index-999 me-2" id="tour-search-web-icon"
                    :class="this.componentTour == true ? 'disable-tour-selection' : ''">
                    <div class="Group_top_three_dot">
                        <div class="Searching_input-box" style="cursor: pointer;">
                            <input type="text" v-model="SearchString" @keydown.enter="filteredList()"
                                placeholder="Search..." />
                            <span class="icon Group_top_three_dot_dropdown" @click="opensearch">
                                <img src="../../../public/dashboard-assets/images/M2/Icon-Set.png" alt=""
                                    class="Searching_search_icon" />
                            </span>
                            <img src="../../../public/dashboard-assets/images/M2/Close_icon.png" alt=""
                                class="close-icon" @click="closesearch" />
                        </div>
                    </div>
                </div>
                <div class="d-flex">
                    <button type="button" class="float-end modail_submit_button  bulkButton mx-2" style="cursor: pointer;">
                        <input id="fileInput" type="file" class="file-upload-input" style="cursor: pointer;"
                            v-on:click="$event.target.value = ''" v-on:change="handleFileUpload($event)"
                            accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
                        <i class=" fa-solid fa-upload pe-2" style="cursor: pointer;"></i>Upload Template
                        Sheet</button>

                    <!-- <div class="col-12 col-sm-12 col-md-3 col-lg-4"> -->
                    <button type="button" class=" float-end modail_submit_button  bulkButton mx-2"
                      @click="DownloadUploadSheet()">
                      <i class="fa-solid fa-download pe-1" style="color: #7b68ee;"></i>
                      Download Template Sheet
                    </button>
                  <!-- </div> -->
                </div>
            </div>
        </div>
        <div :class="{ disabled: isDisabled, enabled: !isDisabled }"
            :style="{ pointerEvents: isDisabled ? 'none' : 'auto' }">
            <ul class="
                nav nav-pills
                mb-3
                partners_top_menu_section_hp
                p-2
                mt-4
                user_tabing_nav_section
                tour-status-tabs
              " id="pills-tab" role="tablist">
                <li class="nav-item" role="presentation">
                    <button class="nav-link btn px-3" :class="activeTab === 'TestCompetencyMaster' ? 'active' : ''"
                        id="test-competency-master-tab" data-bs-toggle="pill" data-bs-target="#completed-candidates"
                        type="button" role="tab" aria-selected="true" @click="changeTabV2('TestCompetencyMaster')">
                        Test Competency Master
                    </button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link btn px-3" :class="activeTab === 'DescriptorMaster' ? 'active' : ''"
                        id="pending-candidates-tab" data-bs-toggle="pill" data-bs-target="#pending-candidates"
                        type="button" role="tab" aria-controls="pending-candidates" aria-selected="false"
                        @click="changeTabV2('DescriptorMaster')">
                        Descriptor Master
                    </button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link btn px-3" :class="activeTab === 'CompetencyRecommendation' ? 'active' : ''"
                        id="in-progress-candidates-tab" data-bs-toggle="pill" data-bs-target="#in-progress-candidates"
                        type="button" role="tab" aria-controls="in-progress-candidates" aria-selected="false"
                        @click="changeTabV2('CompetencyRecommendation')">
                        Competency Recommendation
                    </button>
                </li>

            </ul>
        </div>




        <div v-if="activeTab === 'TestCompetencyMaster'">
            <div class="card p-4" style="z-index: 0;">
                <div class="table-responsive" style="width: 100%;">
                    <table class="table ActiveTestTable">
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th style=" max-width: 300px; word-wrap: break-word; white-space: normal;">
                                    <div class="filter-container ">
                                        <button v-if="this.activeFilter.TestCompetencyMaster == true" ref="filterButton"
                                            @click.stop="toggleFilterDropdown"
                                            class="btn p-0 Group_top_three_dot_dropdown">
                                            <i v-if="this.selectedFilters.length === 0" class="bi bi-funnel"></i>
                                            <i v-else class="bi bi-funnel-fill"></i>
                                        </button>


                                        Name
                                    </div>
                                </th>
                                <th style=" max-width: 300px; word-wrap: break-word; white-space: normal;">Alias Name
                                </th>
                                <th>Parent <br> Competency Id</th>
                                <th style=" max-width: 600px; word-wrap: break-word; white-space: normal;">Definition
                                </th>
                                <th>Color Code</th>
                                <th>Competency <br> Level</th>
                                <th>Edit</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in TestCompetencyMasterList" :key="index">

                                <template v-if="editIndex === index">
                                    <td>{{ item.id }}</td>
                                    <td style=" max-width: 300px; word-wrap: break-word; white-space: normal;"><textarea
                                            style="width: 100%;" rows="3" class="form-control"
                                            v-model="editedInstance.name"></textarea></td>
                                    <td style=" max-width: 300px; word-wrap: break-word; white-space: normal;"><textarea
                                            rows="3" style="width: 100%;" class="form-control"
                                            v-model="this.editedInstance.aliasName"></textarea></td>
                                    <td>{{ item.parentCompetencyId }}</td>
                                    <td style=" max-width: 600px; word-wrap: break-word; white-space: normal;"><textarea
                                            style="overflow-x: auto; overflow-y: auto; resize: vertical;" rows="7"
                                            class="form-control" v-model="this.editedInstance.definition"></textarea>
                                    </td>
                                    <td><input v-model="this.editedInstance.colorCode" :type="inputType"
                                            style="width: 100%;" class="form-control"></td>
                                    <td>{{ item.competencyLevel }}</td>
                                    <td>
                                        <button type="button" class="btn btn-primary"
                                            style="font-weight: 600; border: 2px solid #7b68ee; margin:5% ; border-radius: 15px;"
                                            @click="updateRecord(item, index)">
                                            <span class="mx-2">Save</span> <i
                                                class="fa-regular fa-circle-check fa-lg"></i>
                                        </button>
                                    </td>
                                </template>

                                <template v-else>
                                    <td>{{ item.id }}</td>
                                    <td style=" max-width: 300px; word-wrap: break-word; white-space: normal;">{{
                                        item.name
                                        }} </td>
                                    <td style=" max-width: 300px; word-wrap: break-word; white-space: normal;">{{
                                        item.aliasName }}</td>
                                    <td>{{ item.parentCompetencyId }}</td>
                                    <td style=" max-width: 600px; word-wrap: break-word; white-space: normal;">{{
                                        item.definition }}</td>
                                    <td>{{ item.colorCode }}</td>
                                    <td>{{ item.competencyLevel }}</td>
                                    <td>
                                        <button type="button" class="btn btn-primary"
                                            style="font-weight: 600; border: 2px solid #7b68ee; margin:5% ; border-radius: 15px;"
                                            @click="editItem(index)">
                                            <span class="mx-2"> Edit</span><i
                                                class="fa-regular fa-pen-to-square fa-lg"></i>
                                        </button>
                                    </td>
                                </template>

                            </tr>
                        </tbody>
                    </table>
                </div>



            </div>
            <div class="p-3">
                <div :class="{ disabled: paginationIsDisabled, enabled: !paginationIsDisabled }"
                    :style="{ pointerEvents: paginationIsDisabled ? 'none' : 'auto' }">
                    <paginate v-model="testCompetencyMaster_currentPage" :page-count="testCompetencyMaster_Page_count"
                        :margin-pages="1" :page-range="1" :click-handler="clickCallback" :prev-text="'< Prev'"
                        :next-text="'Next >'" :container-class="'pagination'" :page-class="'page-item'"
                        v-if="activeTab === 'TestCompetencyMaster'">
                    </paginate>
                </div>
            </div>

        </div>


        <div v-if="activeTab === 'DescriptorMaster'">
            <div class="card p-4">
                <div class="table-responsive" style="width: 100%;">
                    <table class="table ActiveTestTable">
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>Competency Id</th>
                                <th>Range Id</th>
                                <th>Range Level</th>
                                <th style=" max-width: 300px; word-wrap: break-word; white-space: normal;">Description
                                </th>
                                <th>Is Active</th>
                                <th>Edit</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in DescriptorMasterList" :key="index">
                                <td>{{ item.id }}</td>
                                <td>{{ item.competencyId }}</td>
                                <td>{{ item.rangeId }}</td>
                                <td>{{ item.rangeLevel }}</td>

                                <td :key="index" style=" max-width: 300px; word-wrap: break-word; white-space: normal;">
                                    <div v-if="editIndex == index">
                                        <textarea style="overflow-x: auto; overflow-y: auto; resize: vertical;" rows="7"
                                            class="form-control" v-model="this.editedInstance.descriptor"></textarea>
                                    </div>
                                    <div v-else>
                                        {{ item.descriptor }}
                                    </div>


                                </td>
                                <td>{{ item.isActive }}</td>
                                <td :key="index">
                                    <div v-if="editIndex === index">
                                        <button type="button" class="btn btn-primary"
                                            style="font-weight: 600; border: 2px solid #7b68ee; margin:5% ; border-radius: 15px;"
                                            @click="updateRecord(item, index)">
                                            <span class="mx-2">Save</span> <i
                                                class="fa-regular fa-circle-check fa-lg"></i>
                                        </button>
                                    </div>
                                    <div v-else><button type="button" class="btn btn-primary"
                                            style="font-weight: 600; border: 2px solid #7b68ee; margin:5% ; border-radius: 15px;"
                                            @click="editItem(index)">
                                            <span class="mx-2"> Edit</span><i
                                                class="fa-regular fa-pen-to-square fa-lg"></i>
                                        </button></div>

                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>


            </div>
            <div class="p-3">
                <div :class="{ disabled: paginationIsDisabled, enabled: !paginationIsDisabled }"
                    :style="{ pointerEvents: paginationIsDisabled ? 'none' : 'auto' }">
                    <paginate v-model="descriptorMaster_currentPage" :page-count="descriptorMaster_Page_count"
                        :margin-pages="1" :page-range="1" :click-handler="clickCallback" :prev-text="'< Prev'"
                        :next-text="'Next >'" :container-class="'pagination'" :page-class="'page-item'"
                        v-if="activeTab === 'DescriptorMaster'">
                    </paginate>
                </div>
            </div>

        </div>

        <div v-if="activeTab === 'CompetencyRecommendation'">
            <div class="card p-4">
                <div class="table-responsive" style="width: 100%;">
                    <table class="table ActiveTestTable">
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>
                                    <div class="filter-container ">
                                        <button v-if="this.activeFilter.CompetencyRecommendation == true"
                                            ref="filterButton" @click.stop="toggleFilterDropdown"
                                            class="btn p-0 Group_top_three_dot_dropdown">
                                            <i v-if="this.selectedFilters.length === 0" class="bi bi-funnel"></i>
                                            <i v-else class="bi bi-funnel-fill"></i>
                                        </button>
                                    Competency Id
                                    </div>



                                </th>
                                <th>Recommend Type</th>
                                <th style=" max-width: 300px; word-wrap: break-word; white-space: normal;">
                                    Recommendation</th>
                                <th>IsPsySec</th>
                                <th>PsySec Id</th>
                                <th>Trait Id</th>
                                <th>IsActive</th>
                                <th>Edit</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in CompetencyRecommendationList" :key="index">

                                <template v-if="editIndex == index">
                                    <td>{{ item.id }}</td>
                                    <td>{{ item.competencyId }}</td>
                                    <td>
                                        <label class="input-hero">
                                            <select class="input_area select_ca" type="text"
                                                v-model="this.editedInstance.recommendType">
                                                <option>
                                                    Positive
                                                </option>
                                                <option>
                                                    Negative
                                                </option>
                                            </select>
                                        </label>
                                    </td>
                                    <td style=" max-width: 300px; word-wrap: break-word; white-space: normal;"><textarea
                                            rows="7" style="width: 100%;" class="form-control"
                                            v-model="this.editedInstance.recommendation"></textarea></td>
                                    <td>
                                        <label class="input-hero">
                                            <select class="input_area select_ca" type="text"
                                                v-model="this.editedInstance.isPsySec">
                                                <option>
                                                    true
                                                </option>
                                                <option>
                                                    false
                                                </option>
                                            </select>
                                        </label>
                                    </td>
                                    <td><input v-model="this.editedInstance.psySecId" type="Number" style="width: 100%;"
                                            class="form-control"></td>
                                    <td><input v-model="this.editedInstance.traitId" type="Number" style="width: 100%;"
                                            class="form-control"></td>
                                    <td>
                                        <label class="input-hero">
                                            <select class="input_area select_ca" type="text"
                                                v-model="this.editedInstance.isActive">
                                                <option>
                                                    true
                                                </option>
                                                <option>
                                                    false
                                                </option>
                                            </select>
                                        </label>
                                    </td>

                                    <td><button type="button" class="btn btn-primary"
                                            style="font-weight: 600; border: 2px solid #7b68ee; margin:5% ; border-radius: 15px;"
                                            @click="updateRecord(item, index)">
                                            <span class="mx-2">Save</span> <i
                                                class="fa-regular fa-circle-check fa-lg"></i>
                                        </button></td>


                                </template>

                                <template v-else>
                                    <td>{{ item.id }}</td>
                                    <td>{{ item.competencyId }}</td>
                                    <td>{{ item.recommendType }}</td>
                                    <td style=" max-width: 300px; word-wrap: break-word; white-space: normal;">{{
                                        item.recommendation }} </td>
                                    <td>{{ item.isPsySec }}</td>
                                    <td>{{ item.psySecId }}</td>
                                    <td>{{ item.traitId }}</td>
                                    <td>{{ item.isActive }}</td>
                                    <td> <button type="button" class="btn btn-primary"
                                            style="font-weight: 600; border: 2px solid #7b68ee; margin:5% ; border-radius: 15px;"
                                            @click="editItem(index)">
                                            <span class="mx-2"> Edit</span><i
                                                class="fa-regular fa-pen-to-square fa-lg"></i>
                                        </button></td>

                                </template>




                            </tr>
                        </tbody>
                    </table>
                </div>


            </div>



        </div>
        <div class="p-3">
            <div :class="{ disabled: paginationIsDisabled, enabled: !paginationIsDisabled }"
                :style="{ pointerEvents: paginationIsDisabled ? 'none' : 'auto' }">
                <paginate v-model="competencyRecommendation_currentPage"
                    :page-count="competencyRecommendation_Page_count" :margin-pages="1" :page-range="1"
                    :click-handler="clickCallback" :prev-text="'< Prev'" :next-text="'Next >'"
                    :container-class="'pagination'" :page-class="'page-item'"
                    v-if="activeTab === 'CompetencyRecommendation'">
                </paginate>
            </div>
        </div>


        <!-- Template for Tippy content -->
        <div ref="filterDropdown" style="display: none;">
            <div class="tippy-filter-content">
                <div class="filter-options">
                    <div class="search-bar p-1">
                        <form class="search-form">
                            <input type="text" v-model="searchfilter" @keyup="Filterresult" placeholder="Search"
                                class="form-control bg-white" /><button class="btn">
                                <i class="fas fa-search"></i>
                            </button>
                        </form>
                    </div>
                    <div v-for="option in filterList" :key="option" class="filter-option p-1">
                        <label>
                            <input type="checkbox" :checked="isSelected(option)" @change="toggleOption(option)" />
                            {{ option }}
                        </label>
                    </div>
                </div>
                <div class="filter-actions">
                    <button @click="applyFilter" class="btn btn-primary m-2">Apply</button>
                    <button @click="selectAllFilter" class="btn btn-primary m-2">Select All</button>
                    <button @click="clearFilter" class="btn btn-primary m-2">Clear</button>
                </div>
            </div>
        </div>

    </div>


</template>

<script>
import { mapActions } from "vuex";
import Paginate from "vuejs-paginate-next";
import readXlsxFile from 'read-excel-file';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
import { validateSuperAdminUser } from '../../platformFeatures/featureUtils'
export default {
    name: "TestCompetencyMaster",
    components: {
        paginate: Paginate,
    },
    data() {
        return {
            TestCompetencyMasterList: [],
            DescriptorMasterList: [],
            CompetencyRecommendationList: [],
            //testCompetencyMaster
            testCompetencyMaster_currentPage: 1,
            testCompetencyMaster_Page_count: 1,
            testCompetencyMaster_offSet: 1,
            testCompetencyMaster_limit: 8,
            testCompetencyMaster_searchString: '',
            testCompetencyMasterFilterList: [],
            testCompetencyMasterNamesList: [],
            //descriptorMaster
            descriptorMaster_currentPage: 1,
            descriptorMaster_Page_count: 1,
            descriptorMaster_offSet: 1,
            descriptorMaster_limit: 8,
            descriptorMaster_searchString: '',
            //competencyRecommendation
            competencyRecommendation_currentPage: 1,
            competencyRecommendation_Page_count: 1,
            competencyRecommendation_offSet: 1,
            competencyRecommendation_limit: 8,
            competencyRecommendation_searchString: '',
            competencyRecommendationFilterList: [],
            competencyRecommendationIdList: [],
            selectedOptions:[],

            tabs: ['TestCompetencyMaster', 'DescriptorMaster', 'CompetencyRecommendation'],
            activeTab: 'TestCompetencyMaster',
            loadedTabs: {},

            competencyManagementMaster: {
                TestCompetencyMaster: [],
                DescriptorMaster: [],
                CompetencyRecommendation: [],
            },

            sheetSchemas: {
                TestCompetencyMaster: {
                    id: 'number',
                    Name: "string",
                    AliasName: "string",
                    parentCompetencyId: 'number',
                    Definition: "string",
                    ColorCode: "string",
                    competencyLevel: 'number',
                    IsActive: 'boolean'
                },
                DescriptorMaster: {
                    //Id: 'number',
                    CompetencyId: 'number',
                    RangeId: 'number',
                    RangeLevel: 'number',
                    Descriptor: "string",
                    IsActive: 'boolean'
                },
                CompetencyRecomendation: {
                    ID: 'number',
                    CompetencyId: 'number',
                    TraitId: 'number',
                    PsySecId: 'number',
                    IsPsySec: 'boolean',
                    RecommendType: "string",
                    Recommendation: "string",
                    IsActive: 'boolean'
                }
            },
            validationErrors: {},
            SearchString: '',
            editmode: false,
            editedInstance: null,
            editIndex: null,
            isDisabled: false,
            paginationIsDisabled: false,

            activeFilter: {
                TestCompetencyMaster: false,
                CompetencyRecommendation: false
            },
            isFilterOpen: false,
            selectedFilters: [],
            tippyInstance: null,
            searchfilter: "",
            filterList: [],
            downloadUrl: ''
        }
    },
    computed:{
        filteredData() {
            // If no filters are applied, return all data
            if (this.selectedFilters.length === 0) {
                return this.data;
            }
            // Filter data based on the selected values
            if(this.activeFilter.TestCompetencyMaster == true){
                return this.testCompetencyMasterFilterList.filter(row => {
                return this.selectedFilters.includes(row.name);
            });
            }
            else{
                return this.competencyRecommendationFilterList.filter(row => {
                    return this.selectedFilters.includes(row.competencyId); // Replace 'category' with your column name
            });
            }   
        }
    },
    created(){
        validateSuperAdminUser();
    },
    methods: {
        ...mapActions([
            "GetTestCompetencyMaster",
            "GetDescriptorMaster",
            "GetCompetencyRecommendation",
            "ShowWarningMessage",
            "PostCompetencyManagementMaster",
            "UpdateTestCompetencyMaster",
            "UpdateDescriptorMaster",
            "UpdateCompetencyRecommendation"]),

        async getTestCompetencyMaster(pageNum) {
            var response = await this.GetTestCompetencyMaster({
                Limit: this.testCompetencyMaster_limit,
                OffSet: this.testCompetencyMaster_offSet,
                //Search : "",
            });

            if (response.status) {
                this.TestCompetencyMasterList = response.object.data.testCompetencyMaster;
                //console.log(Math.ceil(response.object.data.filterCount / this.limit));
            }
            this.loadedTabs['TestCompetencyMaster'] = true;
            this.testCompetencyMaster_Page_count = response
                ? Math.ceil(response.object.data.filterCount / this.testCompetencyMaster_limit)
                : 0;
            this.testCompetencyMaster_currentPage = pageNum;
        },
        async getDescriptorMaster(pageNum) {
            var response = await this.GetDescriptorMaster({
                Limit: this.descriptorMaster_limit,
                OffSet: this.descriptorMaster_offSet,
                //Search : "",
            });
            if (response.status) {
                this.DescriptorMasterList = response.object.data.descriptorMaster;
            }
            this.loadedTabs['DescriptorMaster'] = true;
            this.descriptorMaster_Page_count = response
                ? Math.ceil(response.object.data.filterCount / this.descriptorMaster_limit)
                : 0;
            this.descriptorMaster_currentPage = pageNum;
        },
        async getCompetencyRecommendation(pageNum) {
            var response = await this.GetCompetencyRecommendation({
                Limit: this.competencyRecommendation_limit,
                OffSet: this.competencyRecommendation_offSet,
                //Search : "",
            });
            if (response.status) {
                this.CompetencyRecommendationList = response.object.data.competencyRecommendation;
            }
            this.loadedTabs['CompetencyRecommendation'] = true;
            this.competencyRecommendation_Page_count = response
                ? Math.ceil(response.object.data.filterCount / this.competencyRecommendation_limit)
                : 0;
            this.competencyRecommendation_currentPage = pageNum;
        },
        async clickCallback(pageNum) {

            if (this.activeTab === 'TestCompetencyMaster') {
                this.testCompetencyMaster_offSet = (pageNum - 1) * this.testCompetencyMaster_limit + 1;
                if (this.testCompetencyMaster_searchString.length > 0) {
                    await this.filteredList(pageNum);
                }
                else {
                    await this.getTestCompetencyMaster(pageNum);
                }

            }
            if (this.activeTab === 'DescriptorMaster') {
                this.descriptorMaster_offSet = (pageNum - 1) * this.descriptorMaster_limit + 1;
                if (this.descriptorMaster_searchString.length > 0) {
                    await this.filteredList(pageNum);
                }
                else {
                    await this.getDescriptorMaster(pageNum);
                }
            }
            if (this.activeTab === 'CompetencyRecommendation') {
                this.competencyRecommendation_offSet = (pageNum - 1) * this.competencyRecommendation_limit + 1;
                if (this.competencyRecommendation_searchString.length > 0) {
                    await this.filteredList(pageNum);
                }
                else {
                    await this.getCompetencyRecommendation(pageNum);
                }
            }
        },
        changeTabV2(tab) {
            this.activeTab = tab;
            this.selectedFilters = [];
            this.filterList = [];
            this.activeFilter.TestCompetencyMaster = false;
            this.activeFilter.CompetencyRecommendation = false;
            if (!this.loadedTabs[tab]) {
                this.loadTabData(tab);
            }
            this.isDisabled = false;
            this.paginationIsDisabled = false;
            
        },
        async loadTabData(tab) {
            if (tab === 'TestCompetencyMaster') {
                await this.getTestCompetencyMaster();
            } else if (tab === 'DescriptorMaster') {
                await this.getDescriptorMaster();
            } else if (tab === 'CompetencyRecommendation') {
                await this.getCompetencyRecommendation();
            }
        },
        isSheetValid(sheetName) {
            return Object.prototype.hasOwnProperty.call(this.validationErrors, sheetName)
        },
        async handleFileUpload(event) {
            if (event) {
                if (event.target.files[0].type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                    this.ShowWarningMessage("Please select valid file format");
                    console.log("Please select valid file format");
                    return;
                }
                const file = event.target.files[0];

                const sheetNames = await readXlsxFile(file, { getSheets: true })
                // console.log('Sheet names:', sheetNames)
                const result = {}

                for (const sheet of sheetNames) {
                    const rows = await readXlsxFile(file, { sheet: sheet.name })

                    // console.log('sdfgh', rows);
                    const [header, ...dataRows] = rows;
                    const schema = this.sheetSchemas[sheet.name];

                    const jsonData = dataRows.map((row, rowIndex) => {
                        return header.reduce((obj, key, index) => {

                            const expectedType = schema[key];

                            const Value = row[index];
                            if(key=="RecommendType"){
                                if(!(Value=="Positive" || Value=="Negative")){
                                    this.validationErrors[sheet.name].push(`"Invalid entry in RecommendType"`);
                                }
                            }
                            if (!this.isSheetValid(sheet.name)) {
                                // console.log("sheetName::",sheet.name,"-->Status::",this.isSheetValid(sheet.name))
                                this.validationErrors[sheet.name] = [];
                                // console.log("this.validationErrors[sheet.name]::",this.validationErrors[sheet.name])
                            }

                            //this.validationErrors[sheet.name] = []
                            obj[key] = this.validateCellValue(Value, expectedType, key, rowIndex, this.validationErrors[sheet.name]);
                            //console.log(obj[key]);

                            return obj
                        }, {})
                    })

                    result[sheet.name] = jsonData;
                }

                //console.log("this.validationErrors::",this.validationErrors, this.validationErrors["CompetencyRecomendation"])
                // console.log('sdsadfghgh', result);
                this.competencyManagementMaster = result;
                // console.log("weeeeeeeeeee",this.validationErrors);
                //console.log("sssssssssss",this.validationErrors["CompetencyRecomendation"].length);
                if (this.validationErrors["TestCompetencyMaster"]?.length ?? 0 > 0) {
                    // console.error('Validation Errors:', this.validationErrors["TestCompetencyMaster"])
                    this.ShowWarningMessage("TestCompetencyMaster" + this.validationErrors["TestCompetencyMaster"].toString());
                }
                else if (this.validationErrors["CompetencyRecomendation"]?.length ?? 0 > 0) {
                    // console.error('Validation Errors:',typeof this.validationErrors["CompetencyRecomendation"])data.class?.length ?? 0
                    this.ShowWarningMessage("CompetencyRecomendation: " + this.validationErrors["CompetencyRecomendation"].toString());
                }
                else if (this.validationErrors["DescriptorMaster"]?.length ?? 0 > 0) {
                    this.ShowWarningMessage("DescriptorMaster" + this.validationErrors["DescriptorMaster"].toString());
                }
                else {
                    //console.log("here");
                    await this.postCompetencyManagementMaster(this.competencyManagementMaster);
                }
            }
        },
        validateCellValue(value, expectedType, key, rowIndex, errors) {

            if (value === '' || value === undefined || value === null) {
                return null
            }

            const actualType = typeof value
            // console.log("shr",isNaN(Number(value)),expectedType);
            if (expectedType == 'number') {
                if (isNaN(Number(value))) {
                    // console.log("shr1",isNaN(Number(value)));

                    //console.log("errors::", errors)

                    errors.push(`"${key}" should be a number."`);
                    // console.log("errors",errors);
                    return null
                }
                return Number(value)
            }

            if (expectedType === 'string') {
                if (actualType !== 'string') {
                    errors.push(`"${key}" should be a string."`)
                    return null
                }
                return value
            }

            if (expectedType === 'boolean') {
                if (value != 0 && value != 1) {
                    errors.push(`"${key}" should be a boolean."`)
                    return null
                }
                return value
            }


            return value
        },
        opensearch() {
            document.querySelector(".Searching_input-box").classList.add("open");
        },
        async closesearch() {
            document.querySelector(".Searching_input-box").classList.remove("open");
            this.SearchString = "";
            this.isDisabled = false;
            this.paginationIsDisabled = false;
            this.activeFilter.TestCompetencyMaster = false;
            this.activeFilter.CompetencyRecommendation = false;
            await this.filteredList();
        },
        async postCompetencyManagementMaster(data) {
            await this.PostCompetencyManagementMaster(data);
        },
        async filteredList(pageNum) {
            // this.input = this.input.trim();
            //this.searchDisable = true;
            var list;
            if (this.activeTab === 'TestCompetencyMaster') {
                this.testCompetencyMaster_searchString = this.SearchString;
                list = await this.GetTestCompetencyMaster({
                    OffSet: this.testCompetencyMaster_offSet,
                    Limit: this.testCompetencyMaster_limit,
                    searchString: encodeURIComponent(this.testCompetencyMaster_searchString),
                });
                this.testCompetencyMaster_Page_count = list
                    ? Math.ceil(list.object.data.filterCount / this.testCompetencyMaster_limit)
                    : 0;
                this.testCompetencyMaster_currentPage = pageNum;
                // console.log("datttttaaaaaaaaaaaaa", list);
                this.TestCompetencyMasterList = list.object.data.testCompetencyMaster;
                let all = await this.GetTestCompetencyMaster({
                    OffSet: this.testCompetencyMaster_offSet,
                    Limit: 80,
                    searchString: encodeURIComponent(this.testCompetencyMaster_searchString),
                });
                this.testCompetencyMasterFilterList = all.object.data.testCompetencyMaster;
                const names = this.testCompetencyMasterFilterList.map((p) => p.name);
                this.testCompetencyMasterNamesList = [...new Set(names)];
                this.filterList=this.testCompetencyMasterNamesList;
                this.$nextTick(() => {
                    this.initTippy();
                });
                if (this.SearchString.toString().length === 0) {
                    this.activeFilter.TestCompetencyMaster = false;
                    this.testCompetencyMasterNamesList = [];
                }else{
                    this.activeFilter.TestCompetencyMaster=true;
                    this.activeFilter.CompetencyRecommendation = false;
                }

            } else if (this.activeTab === 'DescriptorMaster') {
                this.descriptorMaster_searchString = this.SearchString;
                list = await this.GetDescriptorMaster({
                    OffSet: this.descriptorMaster_offSet,
                    Limit: this.descriptorMaster_limit,
                    searchString: encodeURIComponent(this.descriptorMaster_searchString),
                });
                this.descriptorMaster_Page_count = list
                    ? Math.ceil(list.object.data.filterCount / this.descriptorMaster_limit)
                    : 0;
                this.descriptorMaster_currentPage = pageNum;
                this.DescriptorMasterList = list.object.data.descriptorMaster;
            } else if (this.activeTab === 'CompetencyRecommendation') {
                this.competencyRecommendation_searchString = this.SearchString;
                list = await this.GetCompetencyRecommendation({
                    OffSet: this.competencyRecommendation_offSet,
                    Limit: this.competencyRecommendation_limit,
                    searchString: encodeURIComponent(this.competencyRecommendation_searchString),
                });
                this.competencyRecommendation_Page_count = list
                    ? Math.ceil(list.object.data.filterCount / this.competencyRecommendation_limit)
                    : 0;
                this.competencyRecommendation_currentPage = pageNum;
                this.CompetencyRecommendationList = list.object.data.competencyRecommendation;
                let all = await this.GetCompetencyRecommendation({
                    OffSet: this.competencyRecommendation_offSet,
                    Limit: 50,
                    searchString: encodeURIComponent(this.competencyRecommendation_searchString),
                });
                this.competencyRecommendationFilterList = all.object.data.competencyRecommendation;
                const ids = this.competencyRecommendationFilterList.map((p) => p.competencyId);
                this.competencyRecommendationIdList = [...new Set(ids)];
                this.filterList=this.competencyRecommendationIdList;
                //console.log(this.competencyRecommendationIdList);
                //console.log(this.competencyRecommendationFilterList);
                this.$nextTick(() => {
                    this.initTippy();
                });
                if (this.SearchString.toString().length === 0) {
                    this.activeFilter.CompetencyRecommendation = false;
                    this.competencyRecommendationIdList = [];
                }else{
                    this.activeFilter.CompetencyRecommendation=true;
                    this.activeFilter.TestCompetencyMaster = false;
                }
            }
        },
        editItem(index) {
            this.editIndex = index;
            this.isDisabled = true;
            this.paginationIsDisabled = true;
            if (this.activeTab === 'TestCompetencyMaster') {
                this.editedInstance = { ...this.TestCompetencyMasterList[index] }
            }
            else if (this.activeTab === 'DescriptorMaster') {
                this.editedInstance = { ...this.DescriptorMasterList[index] }
            }
            else if (this.activeTab === 'CompetencyRecommendation') {
                this.editedInstance = { ...this.CompetencyRecommendationList[index] }
            }

        },
        async updateRecord(item, index) {
            this.editIndex = null;
            this.isDisabled = false;
            this.paginationIsDisabled = false;
            let data = this.editedInstance;

            var record = null;
            if (this.activeTab === 'TestCompetencyMaster') {
                record = await this.UpdateTestCompetencyMaster(data);
                this.TestCompetencyMasterList[index] = record.object.data;
            }
            else if (this.activeTab === 'DescriptorMaster') {

                record = await this.UpdateDescriptorMaster(data);
                this.DescriptorMasterList[index] = record.object.data;
                item.descriptor = this.DescriptorMasterList[index].descriptor
            }
            else if (this.activeTab === 'CompetencyRecommendation') {
                record = await this.UpdateCompetencyRecommendation(data);
                this.CompetencyRecommendationList[index] = record.object.data;
            }
            
            return record;
        },
        openFileInput() {
            this.$refs.fileInput.click();
        },
        toggleFilterDropdown() {
            this.isFilterOpen = !this.isFilterOpen;

            if (this.isFilterOpen) {
                this.tippyInstance.show();
            } else {
                this.tippyInstance.hide();
            }

        },
        isSelected(option) {
            return this.selectedFilters.includes(option);
        },

        toggleOption(option) {
            const index = this.selectedFilters.indexOf(option);
            if (index === -1) {
                this.selectedFilters.push(option);
            } else {
                this.selectedFilters.splice(index, 1);
            }
        },
        applyFilter() {
            this.isFilterOpen = false;
            this.paginationIsDisabled = true;
            
            //console.log(this.competencyRecommendationFilterList.filter(row => {this.selectedFilters.includes(row.competencyId)}));
            if(this.activeFilter.TestCompetencyMaster == true){
                this.TestCompetencyMasterList = this.filteredData;
            }
            else if(this.activeFilter.CompetencyRecommendation == true){
                this.CompetencyRecommendationList = this.filteredData;
            }

            this.tippyInstance.hide();
        },
        selectAllFilter(){
            this.filterList.forEach(element => {
                this.selectedFilters.push(element   );
            });
        },
        clearFilter() {
            this.selectedFilters = [];
            this.isFilterOpen = false;
        },
        closeDropdown(event) {
            if (!event.target.closest('.filter-container') && this.isFilterOpen) {
                this.isFilterOpen = false;
            }
        },
        initTippy() {
            if (!this.$refs.filterButton || !this.$refs.filterDropdown) {
                console.error('Filter refs not found');
                return;
            }
            this.tippyInstance = tippy(this.$refs.filterButton, {
                content: this.$refs.filterDropdown,
                theme: 'light',
                interactive: true,
                trigger: 'manual',
                placement: 'bottom',
                arrow: true,
                appendTo: document.body,
                maxWidth: 'none',
                onShow: () => {
                    // Ensure the content is visible when the tippy is shown
                    this.$refs.filterDropdown.style.display = 'block';
                },

            });
        },
        Filterresult() {
            //var temp = this.competencyRecommendationIdList
            if(this.activeFilter.TestCompetencyMaster == true){
                this.filterList = this.testCompetencyMasterNamesList.filter((element) =>
                element.toString()
                    .includes(this.searchfilter.toString())
            );
            }
            else if(this.activeFilter.CompetencyRecommendation == true){
                this.filterList = this.competencyRecommendationIdList.filter((element) =>
                element.toString()
                    .includes(this.searchfilter.toString())
            );
            }
            
        },
        DownloadUploadSheet() {
            this.downloadUrl = 'https://testdelivery-mumbai.s3.ap-south-1.amazonaws.com/BulkUploadTemplate/Competency/TestCompetencyManagement.xlsx';
            window.open(this.downloadUrl);
        },
    },


    async mounted() {
        await this.getTestCompetencyMaster();
    }


}
</script>

<style scoped>
.pagination {
    justify-content: flex-end;
}

.pagination .page-item.active .page-link {
    font-weight: 600;
    background: #ffc801;
}

.pagination .page-item:last-child .page-link {
    background-color: transparent;
    border: none;
    width: 100% !important;
}

.pagination .page-item:first-child .page-link {
    background-color: transparent;
    border: none;
    width: 100% !important;
}

.pagination .page-item.disabled .page-link {
    color: rgb(130, 130, 130) !important;
    cursor: no-drop !important;
}

.file-upload-input {
    position: absolute;
    margin: 0;
    padding: 0;
    width: 20vh;
    height: 5vh;
    outline: none;
    opacity: 0;
    cursor: pointer;
}

.disabled {
    opacity: 0.5;
    background-color: #f2f2f2;
    display: flex;
}

.table thead th {
    text-transform: capitalize;
    color: #000;
    font-size: 15px;
    font-weight: bold;
}
.tippy-box[data-theme~="light"] {
    background-color: #fff;
    color: #333;
    border: 1px solid #ddd;
    border-radius: 6px;
    box-shadow: 0px 2px 6px rgba(254, 254, 254, 0.15);
}

.tippy-arrow {
    display: none;
    color: #fff;
    box-shadow: -6px 0px 0px rgba(0, 0, 0, 0.1);
}
.tippy-filter-content{
    height: 310px;
    overflow-x: hidden;
    overflow-y: auto;
}
.bulkButton {
  font-size: 13px;
  height: 40px;
  font-weight: 600;
  width: max-content;
}
</style>